/* eslint-disable @typescript-eslint/no-empty-function */
import { FormRules } from "element-plus"
import XSearchForm from '@/components/x-search-form/XSearchForm.vue'
import { BaseForm } from "./BaseForm"

export const enum EVENT_NAME {
  SEARCH = 'search',
  RESET = 'reset'
}

export class SearchForm extends BaseForm {
  /**
   * 构造搜索表单
   * @param el 挂载节点
   * @param items 表单项
   * @param elFormProps el-form属性
   */
  constructor(
    el: Element,
    items: FormItem[],
    elFormProps?: FormProps<FormRules>
  ) {
    super(el, XSearchForm as VueComponent, {
      items,
      elFormProps,
    })
  }

  /**
   * 搜索事件
   * @memberof SearchForm
   */
  get onSearch(): ((formData?: { [key: string]: any }) => void) | undefined {
    return this.handler[EVENT_NAME.SEARCH]
  }

  set onSearch(fn) {
    this.handler[EVENT_NAME.SEARCH] = fn
  }

  /**
   * 重置事件
   * @memberof SearchForm
   */
  get onReset(): (() => void) | undefined {
    return this.handler[EVENT_NAME.RESET]
  }

  set onReset(fn) {
    this.handler[EVENT_NAME.RESET] = fn
  }
}

